import React, { useEffect, useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import {useSelector } from "react-redux";
// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import styles from "assets/jss/material-dashboard-react/components/customTabsStyle.js";
import { Box, Typography, useMediaQuery } from "@material-ui/core";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { fieldAgentTabsName } from "assets/properties/properties";

const useStyles = makeStyles(styles);

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
export default function CustomTabs(props) {
  const [value, setValue] = React.useState(0);
  const { authToken } = useSelector((state) => state.login.authData);
  const [sanctionLink,setSanctionLink] =useState("")
  const [hideAffidavit, setHideAffidavit] = useState(false);
  const [hideSanctionLetterPartB, setHideSanctionLetterPartB] = useState(false);
  const { headerColor,handleClose, plainTabs, tabs, title, rtlActive, currentTab, setCurrentTab, clickAbleTab, substatus, status, loanApplicationId,enabledInsurance, fieldAgent, clickableTab } = props;
  const smallScreen = useMediaQuery("(max-width: 1000px)");
  const tabValues = substatus === "POST_PLEDGE" ? 11 : 9;
  const getEsignLetter=async()=>{
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    if(!res?.data?.error_code){
       if(res?.data?.sanctionLetterLink){
        setSanctionLink(res?.data?.sanctionLetterLink);
      }
    }
  };

  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
      method: "GET",
      authToken: authToken,
    });
    setHideAffidavit(parseAndSetFlag(result?.data?.hideAffidavitTabFlag));
    setHideSanctionLetterPartB(parseAndSetFlag(result?.data?.hideSanctionLetterPartBFlag));
  };

  const parseAndSetFlag = (flag) => {
    return typeof flag === "boolean" ? flag : flag === "true";
  };

  useEffect(() => {
    if (status === "DISBURSALTOLMS" && substatus !== "PRE_PLEDGE" && !sanctionLink) {
      getEsignLetter();
    }
  }, [status, sanctionLink]);

  useEffect(() => {
    getFeatureFlag();
  }, []);

  const handleChange = (event, value) => {
    if(clickAbleTab && (status !== "DISBURSALTOLMS" || status === "DISBURSALTOLMS" && (substatus ==="PRE_PLEDGE" || substatus !=="PRE_PLEDGE" && (sanctionLink || (!sanctionLink && value <= tabValues))))){
      if((status === "DISBURSAL" && Number(value) <= Number(clickableTab)) || status !== "DISBURSAL"  ){
        setCurrentTab(value)
      }
    }else{
       setValue(value);
    }
  };
  const classes = useStyles();
  const cardTitle = classNames({
    [classes.cardTitle]: true,
    [classes.cardTitleRTL]: rtlActive,
  });
  const tabValue = clickAbleTab ? currentTab : value;
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number,
    value: PropTypes.number,
  };
  let newTabs =[];
  console.log(substatus,"dakjfjbakdj")
  if(substatus ==="PRE_PLEDGE"){
      newTabs = tabs.filter((item)=> item.tabName !== fieldAgentTabsName?.repaymentSchdule && item.tabName !== "Loan Details" && item.tabName !== "Sanction Letter Part-A" && item.tabName !== "Esign Part-A" && item.tabName !== "Sanction Letter Part-B" && item.tabName !== "Esign Part-B" && item.tabName !=="Affidavit")
  }else if(substatus ==="POST_PLEDGE"){
    newTabs = tabs.filter((item)=> item.tabName !== "BT Kit" && item.tabName !== "Upload Kit")
  }
  else{
      newTabs = tabs.filter((item)=>item.tabName !== "Lender Details " && item.tabName !== "Pawan Ticket Details" && item.tabName !== "BT Kit" && item.tabName !== "Upload Kit")
  }

  if (hideAffidavit) {
    newTabs = newTabs.filter((item) => item.tabName !== "Affidavit");
  }
  if(!enabledInsurance){
    newTabs = newTabs.filter((item) => item.tabName !== "Insurance Eligiblity" && item.tabName !== "Insurance Letter" && item.tabName !== "Insurance E-sign");
  }
  if(hideSanctionLetterPartB){
    newTabs = newTabs.filter((item) => item.tabName !== "Sanction Letter Part-B" &&  item.tabName !== "Esign Part-B" &&  item.tabName !== "Affidavit" );
  }
  return (
    <Card plain={plainTabs}>
      {title !== undefined ? <div className={cardTitle}>{title}</div> : null}
      <>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          classes={{
            root: classes.tabsRoot,
            indicator: classes.displayNone,
            scrollButtons: classes.displayNone,
          }}
          className={classes.container}
          orientation={smallScreen ? "horizonal" : "vertical"} 
          variant="scrollable"
          scrollButtons="auto"
        >
          {newTabs.map((prop, key) => {
            var icon = {};
            let label = ""
            if (prop.icon) {
              icon = {
                icon:  <img src={prop.icon} alt={""} className={classNames(classes.itemIcon)}></img>,
              };
            }
            if(prop.tabName === "Sanction Letter Part-A" && hideSanctionLetterPartB){
              label = "Sanction Letter"
            }else if (prop.tabName === "Esign Part-A" && hideSanctionLetterPartB){
              label = "Esign"
            }else{
              label=prop.tabName
            }
            return (
              <Tab
              classes={{
                root: classes.tabRootButton,
                selected: classes.tabSelected,
                wrapper: classes.tabWrapper,
              }}
              style={{marginBottom: fieldAgent ? '8px' : '20px'}}
              key={key}
              label={label}
              className={classes.itemText}
              {...icon}
              />
            );
          })}
        </Tabs>
        {newTabs.map((prop, key) => {
          if (key === tabValue) {
            return (
            <div key={key} style={{height: fieldAgent ? 'calc(100vh - 200px)': '100%', overflowY:'auto',width: smallScreen ? "100%" : "calc(100% - 215px)", position:'relative',display:'flex'}}>
            
              <div
          
                role="tabpanel"
                id={`vertical-tabpanel-${key}`}
                className={classes.tabPannel}
                aria-labelledby={`vertical-tab-${key}`}
              >
                <>
                  <Box sx={{ p: 3 }}> 
                  {prop.tabContent}
                </Box>
                {fieldAgent && (
                  smallScreen ? (
                  <IconButton
                    onClick={() => handleClose()}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                      zIndex: 10,
                      padding: "8px",
                    }}
                  >
                    <ArrowBackIcon style={{ color: "#000", fontSize: "24px" }} />
                  </IconButton>
                  ) : (
                    <div
                      role="button"
                      className={classes.nextButton}
                      onClick={() => handleClose()}
                      style={{
                        display: "flex",
                        marginRight: "14%",
                        justifyContent: "right",
                        position: "absolute",
                        top: "3%",
                        right: "0",
                      }}
                    >
                      Back To Home
                    </div>
                  )
                )}
              </>
              </div>
            </div>
            );
          }
          return null;
        })}
        </>
    </Card>
  );
}

CustomTabs.propTypes = {
  headerColor: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
  ]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string,
      tabIcon: PropTypes.object,
      tabContent: PropTypes.node,
    })
  ),
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool,
  currentTab: PropTypes.bool,
  setCurrentTab: PropTypes.func,
  clickAbleTab: PropTypes.bool,
};